










import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ProjectModel } from "../models";

import ProjectTable from "../components/ProjectTable.vue";

const pStore = namespace("projects");
const snackStore = namespace("snackbar");

@Component({
  components: { ProjectTable },
})
export default class MyProjects extends Vue {
  @pStore.Getter allProjects!: ProjectModel;

  @pStore.Action fetchProjects!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  mounted(): void {
    this.fetchProjects().catch(() => {
      this.defaultError();
    });
  }
}
